$mol_email $mol_string
	type \text
	keyboard \email
	hint \E-mail

